export default __webpack_public_path__ + "static/media/ISEO CLASS 6 SYLLABUS.f3f99510.pdf";